module.exports = function() {
  return new Worker(__webpack_public_path__ + "b7aa99ccdb53f5cfc8d8.worker.js");
};